<header>
  <title>{{nombre}}</title>
</header>
<router-outlet></router-outlet>

<modal-open-point id="modal-no-implemented">
  <div normal>
    <modal-no-implemented></modal-no-implemented>
  </div>
</modal-open-point>